<!-- SIDEBAR MENU

  Rendered as the fixed desktop sidebar, and as the contents of the mobile
  burger drawer (drawerMode) where it is always expanded and additionally
  carries the workspace and profile rows — those live in the global header on
  desktop, but the header has no room for them on mobile.
-->

@if (deviceType.isDesktop || drawerMode) {
<nav
  class="med_sidebar-menu nav flex-column justify-content-between align-items-center"
  [ngClass]="drawerMode ? 'med_sidebar-drawer w-100' : 'position-absolute'"
  [style.width]="drawerMode ? null : isExpanded ? '270px' : '65px'"
  style="transition: width 0.2s ease-in-out">
  <div class="d-flex flex-column justify-content-start align-items-start w-100">
    <!-- Logo and workspace switcher live in the global header on desktop. -->
    @if (drawerMode) {
    <app-manage-workspace-popup class="w-100" variant="row" (workspaceSwitched)="onWorkspaceSwitched()">
    </app-manage-workspace-popup>
    }

    <button
      type="button"
      class="btn w-100 py-3 gap-2"
      [ngClass]="{
          active: checkLinkActive([urlService.getSpacesPageURL()]),
          'color-gray btn-sidebar-disabled': !hasSubscription,
          'btn-sidebar': hasSubscription,
        }"
      (click)="hasSubscription ? navigateToSpaces() : null"
      [matTooltip]="!isExpanded ? ('my_spaces' | translate) : null"
      matTooltipShowDelay="500"
      matTooltipPosition="right"
      matTooltipClass="med_menu-tooltip"
      id="menu_my_spaces"
      [@iconAnim]="isExpanded ? 'expanded' : 'collapsed'"
      data-cy="med_nav_btn_spaces">
      <app-icon icon="grid-2" class="icon-light flex-shrink-0" />
      @if (isExpanded) {
      <p
        class="xxl-body text-nowrap overflow-hidden"
        [ngClass]="{
              'color-gray': !hasSubscription,
            }">
        {{ "my_spaces" | translate }}
      </p>
      }
    </button>

    <button
      type="button"
      [ngClass]="{
          active: checkLinkActive([urlService.getSearchHomePageURL()]),
          'color-gray btn-sidebar-disabled': !hasSubscription,
          'btn-sidebar': hasSubscription,
        }"
      class="btn w-100 py-3 gap-2"
      (click)="hasSubscription ? goSearch() : null"
      [matTooltip]="!isExpanded ? ('search' | translate) : null"
      matTooltipShowDelay="500"
      matTooltipPosition="right"
      matTooltipClass="med_menu-tooltip"
      id="menu_search"
      [@iconAnim]="isExpanded ? 'expanded' : 'collapsed'"
      data-cy="med_nav_btn_search">
      <app-icon icon="magnifying-glass" class="icon-light flex-shrink-0" />
      @if (isExpanded) {
      <p
        class="xxl-body text-nowrap overflow-hidden"
        [ngClass]="{
              'color-gray': !hasSubscription,
            }">
        {{ "search" | translate }}
      </p>
      }
    </button>
    <button
      type="button"
      class="btn w-100 py-3 gap-2"
      [ngClass]="{
          active: checkLinkActive([urlService.getConnectorsPageURL()]),
          'color-gray btn-sidebar-disabled': !hasSubscription,
          'btn-sidebar': hasSubscription,
        }"
      (click)="hasSubscription ? gotoConnectorsPage() : null"
      [matTooltip]="!isExpanded ? ('my_connectors' | translate) : null"
      matTooltipShowDelay="500"
      matTooltipPosition="right"
      matTooltipClass="med_menu-tooltip"
      id="menu_my_connectors"
      [@iconAnim]="isExpanded ? 'expanded' : 'collapsed'"
      data-cy="med_nav_btn_connectors">
      <app-icon icon="plug" class="icon-light flex-shrink-0" />
      @if (isExpanded) {
      <p
        class="xxl-body text-nowrap overflow-hidden"
        [ngClass]="{
              'color-gray': !hasSubscription,
            }">
        {{ "my_connectors" | translate }}
      </p>
      }
    </button>
    @if (hasSubscription && (userProfile?.role === 'client_admin' || userProfile?.role === 'super_admin')) {
    <button
      type="button"
      class="btn btn-sidebar w-100 py-3 gap-2"
      [ngClass]="{ active: checkLinkActive([urlService.getAgentsPageURL()]) }"
      (click)="navigateToAgents()"
      [matTooltip]="!isExpanded ? ('agents' | translate) : null"
      matTooltipShowDelay="500"
      matTooltipPosition="right"
      matTooltipClass="med_menu-tooltip"
      id="menu_agents"
      [@iconAnim]="isSidebarExpanded ? 'expanded' : 'collapsed'"
      data-cy="med_nav_btn_agents">
      <app-icon icon="robot" class="icon-light flex-shrink-0" />
      @if (isExpanded) {
      <p class="xxl-body text-nowrap overflow-hidden">{{ "agents" | translate }}</p>
      }
    </button>
    }
    @if (fromOnboarding && !drawerMode) {
    <div
      class="med_onboarding-wrapper pop d-flex flex-column align-items-start position-absolute"
      (click)="closeOnboardingPopMessage()">
      <div class="med_onboarding position-relative w-100 h-100">
        <div class="med_arrow-icon position-absolute d-flex justify-content-start align-items-center">
          <app-icon icon="chevron-left" class="icon-light"></app-icon>
        </div>
        <h3 class="xs-title mb-1">{{ "connect_your_world" | translate }}</h3>
        <p class="m-body">{{ "onboarding_helper_tooltip_text" | translate }}</p>
      </div>
    </div>
    }

    @if (!hasSubscription && !loading && drawerMode) {
    <div class="subscription_card cursor-pointer" (click)="gotoPurchasePage($event); emitCloseMobileMenu(true)">
      <app-icon icon="lightbulb-on"></app-icon>
      <span class="title">{{ "upgrade_your_plan" | translate }}</span>
      <span class="body_txt">
        {{ "get_unlimited_searches" | translate }}
      </span>
    </div>
    }
  </div>

  <div class="d-flex flex-column justify-content-end align-itmes-center w-100">
    <!-- Profile menu lives in the global header on desktop. -->
    @if (drawerMode) {
    <app-popover variant="row" [isSidebarExpanded]="true" class="justify-content-start w-100"></app-popover>
    }
    @if (isExpanded) {
    <div class="med_borders mb-2"></div>
    }
    <div class="w-100 d-flex justify-content-start">
      <button
        type="button"
        class="btn btn-sidebar w-100 py-3 gap-2"
        [@iconAnim]="isExpanded ? 'expanded' : 'collapsed'"
        (click)="goToFeedJolt()">
        <app-icon
          icon="bullhorn"
          class="icon-light flex-shrink-0"
          [matTooltip]="!isExpanded ? ('provide_feedback' | translate) : null"
          matTooltipShowDelay="500"
          matTooltipPosition="right"
          matTooltipClass="med_menu-tooltip" />
        @if (isExpanded) {
        <p class="xxl-body text-nowrap overflow-hidden">
          {{ "provide_feedback" | translate }}
        </p>
        }
      </button>
    </div>
    @if (!drawerMode) {
    <div class="med_btn-toggle-sidebar-wrapper w-100 d-flex justify-content-end">
      <button class="btn btn-toggle-sidebar" (click)="toggleSidebar()">
        @if (isExpanded) {
        <app-icon icon="chevrons-left" class="icon-soft" />
        }
        @if (!isExpanded) {
        <app-icon icon="chevrons-right" class="icon-soft" />
        }
      </button>
    </div>
    }
  </div>
</nav>
}
